<article class="mb-[6rem] relative">
  <app-breadcrumb [items]="['PRESENTATION_SIDEMENU_LIST8_TITLE' | translate]"></app-breadcrumb>

  <section class="sm:px-[9.6rem] px-[7rem]" aria-labelledby="regulary-data-heading">

    <!-- Loading State -->
    @if(isLoader) {
      <div class="fixed inset-0 bg-opacity-50 backdrop-blur-sm flex items-center justify-center" style="z-index: 999"
        role="status" aria-live="polite" aria-label="Loading registration">
        <mat-progress-spinner class="!h-[50px] !w-[50px]" mode="indeterminate" aria-label="Loading" />
      </div>
    }

    <!-- Error State -->
    @if(error && !loading) {
      <div class="flex flex-col justify-center items-center min-h-[400px] py-16">
        <mat-icon class="text-red-500 text-6xl mb-8">error_outline</mat-icon>
        <p class="text-lg text-gray-700 mb-8">{{'REGULATORY_DATA.ERROR' | translate}}</p>
        <button mat-raised-button color="primary" (click)="retryLoad()">
          {{'REGULATORY_DATA.RETRY' | translate}}
        </button>
      </div>
    }

    <!-- Data Content -->
    @if(!loading && !error && processedTopics.length > 0) {
      <div class="flex flex-col gap-[4rem]">
        <h1 id="regulary-data-heading" class="dsr-typescale-title-medium">{{'PRESENTATION_SIDEMENU_LIST8_TITLE' | translate}}</h1>
        <ol class="list-decimal flex flex-col gap-[4rem] w-full list-inside">
          @for (item of processedTopics; track item; let i = $index) {
            <div>
              <li class="!uppercase dsr-typescale-label-large-prominent text-light-dsr-color-primary">
                {{item.title}}
              </li>
              <table class="table w-full mt-[1.6rem]" role="table" [attr.aria-labelledby]="'topic-' + i">
                <caption [id]="'topic-' + i" class="sr-only">{{item.title}}</caption>
                <thead>
                  <tr class="border-solid border-b border-black pl-[0.8rem]">
                    <th scope="col" class="text-start w-1/2 dsr-typescale-body-small-prominent">{{'PRESENTATION_TAB8_TABLE_HEADERTEXT' | translate}}</th>
                    <th scope="col" class="text-start w-1/2 dsr-typescale-body-small-prominent">{{'INFO_POPUP_HEADER' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (detail of item.details; track detail) {
                    <tr class="border-solid h-[5.1rem] border-b border-gray-200 pl-[0.8rem]">
                      <td class="text-start first-letter:!uppercase dsr-typescale-body-small">{{detail.subject}}</td>
                      <td class="text-start first-letter:!uppercase dsr-typescale-body-small">
                        @for (segment of detail.processedTextSegments; track segment) {
                          @if(segment.isLink) {
                            <a
                              [href]="segment.url"
                              target="_blank"
                              rel="noopener noreferrer"
                              [attr.aria-label]="segment.text + ' (opens in new tab)'">
                              <span class="dsr-typescale-body-small border-b-gray-400 border-dotted border-b-2">{{segment.text}}</span>
                            </a>
                          }
                          @if(!segment.isLink) {
                            {{segment.text}}
                          }
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </ol>
      </div>
    }
  </section>
  <div class="flex justify-center w-full mt-[6.8rem]">
    <span class="dsr-typescale-label-small ">{{'REGULATORY_DATA_REGULATION' | translate}}</span>
  </div>
</article>